/* eslint-disable object-shorthand */
import PropTypes from 'prop-types';
import React from 'react';
import { corReversa } from '../../util/color';
import {
  GridArquivo, GridLink, GridLinkInicial, GridLinkLogin, GridLinkTotem,
} from './GridBotaoEstilo';

const GridBotao = ({
  img, label, to, onClick, cor, imgWidth, imgHeight, size, sizeDescricao, type, secretaria, fileName, secretaria2, totem, selecao, selecaoInicial, selecaoTotem, title, className, descricao, inicial,
}) => {
  if (selecaoTotem) {
    return (
      <GridLinkTotem
        to={to}
        onClick={onClick}
        style={{
          backgroundColor: cor, color: corReversa(cor),
        }}
        secretaria={secretaria}
        totem
      >
        <div style={{ marginTop: 15, marginBottom: -10 }}>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: 40 }}>{label}</p>
      </GridLinkTotem>
    );
  }
  if (selecao) {
    return (
      <GridLinkTotem
        to={to}
        onClick={onClick}
        style={{
          backgroundColor: cor,
        }}
        secretaria={secretaria}
        totem
      >
        <div style={{ marginTop: 15 }}>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: 20, maxWidth: 180 }}>{label}</p>
      </GridLinkTotem>
    );
  }
  if (selecaoInicial) {
    return (
      <GridLinkLogin
        to={to}
        onClick={onClick}
        style={{
          backgroundColor: cor,
        }}
        secretaria={secretaria}
      >
        <div style={{ marginTop: 15 }}>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: size, maxWidth: 120 }}>{label}</p>
      </GridLinkLogin>
    );
  }
  if (type === 'arquivo' && img) {
    return (
      <GridArquivo
        onClick={onClick}
        to={to}
        style={{ backgroundColor: cor, color: corReversa(cor) }}
      >
        <div style={{ width: `${imgWidth}%` }}>
          <img src={img} alt="Upload de arquivos" />
        </div>
      </GridArquivo>
    );
  }

  if (secretaria2) {
    // Lógica que só vai adicionar a propriedade 'title' se ela for diferente de vazio, para que não gere um HTML com title vazio.
    const titleProp = title !== '' ? { title: title } : {};

    return (
      <GridLink
        to={to}
        onClick={onClick}
        style={{ backgroundColor: cor, color: corReversa(cor) }}
        secretaria={secretaria}
        className={className}
        {...titleProp}
      >
        <div>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} style={{ filter: 'opacity(0.60)' }} />
        </div>
        <p style={{ fontSize: size, paddingTop: 10, marginBottom: -30 }}>{label}</p>
      </GridLink>
    );
  }

  if (img && totem) {
    return (
      <GridLink
        to={to}
        onClick={onClick}
        style={{ backgroundColor: cor, color: corReversa(cor) }}
        secretaria={secretaria}
        totem
      >
        <div>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: size }}>{label}</p>
      </GridLink>
    );
  }

  if (img && inicial) {
    // Lógica que só vai adicionar a propriedade 'title' se ela for diferente de vazio, para que não gere um HTML com title vazio.
    const titleProp = title !== '' ? { title: title } : {};

    return (
      <GridLinkInicial
        to={to}
        onClick={onClick}
        style={{ backgroundColor: cor, color: corReversa(cor) }}
        secretaria={secretaria}
        className={className}
        {...titleProp}
      >
        <div>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: size }}>{label}</p>

        {descricao && (
          <p style={{ fontSize: sizeDescricao, paddingTop: 0 }}>{descricao}</p>
        )}
      </GridLinkInicial>
    );
  }

  if (img) {
    // Lógica que só vai adicionar a propriedade 'title' se ela for diferente de vazio, para que não gere um HTML com title vazio.
    const titleProp = title !== '' ? { title: title } : {};

    return (
      <GridLink
        to={to}
        onClick={onClick}
        style={{ backgroundColor: cor, color: corReversa(cor) }}
        secretaria={secretaria}
        className={className}
        {...titleProp}
      >
        <div>
          <img src={img} alt="Brasão da cidade" width={imgWidth} height={imgHeight} />
        </div>
        <p style={{ fontSize: size }}>{label}</p>

        {descricao && (
          <p style={{ fontSize: sizeDescricao, paddingTop: 0 }}>{descricao}</p>
        )}
      </GridLink>
    );
  }
  return true;
};

GridBotao.propTypes = {
  cor: PropTypes.string,
  img: PropTypes.string.isRequired,
  secretaria2: PropTypes.bool,
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
  sizeDescricao: PropTypes.number,
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.string,
  secretaria: PropTypes.bool,
  totem: PropTypes.bool,
  fileName: PropTypes.string,
  selecao: PropTypes.bool,
  selecaoInicial: PropTypes.bool,
  selecaoTotem: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  descricao: PropTypes.string,
  inicial: PropTypes.bool,
};

GridBotao.defaultProps = {
  cor: null,
  imgWidth: 100,
  imgHeight: 100,
  label: null,
  onClick: null,
  size: 16,
  sizeDescricao: 13,
  type: null,
  to: '#',
  secretaria: false,
  secretaria2: false,
  fileName: null,
  totem: false,
  selecao: false,
  selecaoInicial: false,
  selecaoTotem: false,
  title: '',
  className: '',
  descricao: '',
  inicial: false,
};

export default GridBotao;
